import { Directive } from '@angular/core';

import { BaseComponent } from '../../../../base/components/base-component';

@Directive()
export class BaseDialogComponent extends BaseComponent {

}
